import AsyncStorage from '@react-native-async-storage/async-storage';
import { mapKeys } from "lodash";

const Reducer = (prevState, action) => {
    switch (action.type) {
      case 'RESTORE_TOKEN':
        return {
          ...prevState,
          isLoading: false,
          userToken: action.token,
          buyerId: action.buyerId,
          buyerData: action.buyerData,
          signupData: action.signupData,
        };
      case 'SIGN_IN':
        return {
          ...prevState,
          isSignout: false,
          userToken: action.token,
          buyerId: action.buyerId,
          buyerData: action.buyerData,
        };
      case 'SIGN_UP':
        return {
          ...prevState,
          isSignout: false,
          userToken: action.token,
          userId: action.userId,
          signupData: action.signupData,
        };
      case 'SIGN_OUT':
        return {
          ...prevState,
          isSignout: true,
          userToken: null,
          userId: null,
          buyerId: null,
          buyerData: null
        };
      case 'UPDATE_USER':
        return {
          ...prevState,
          buyerData: action.buyerData
        };
      case 'UPDATE_SIGNUP_DATA':
        return {
          ...prevState,
          userId: action.userId,
          signupData: action.signupData
        }
      case 'SET_CHAT_INSTANCE':
        return {
          ...prevState,
          chat_instance: action.payload
        }
      case 'SET_INSTALL_PROMPT':
        return {
          ...prevState,
          install_prompt: action.payload
        }
    }
  };

export default Reducer;